import { Luxon } from './luxon';

function isInToday(date: number) {
  return Luxon.DateTime.fromMillis(date).startOf('day').toMillis() === Luxon.DateTime.now().startOf('day').toMillis();
}

export const LuxonFuncs = {
  isInToday,
};
